<template>
	<v-container>
		<!-- <v-app-bar app color="purple">
			<div class="d-flex d-lg-none">
				<v-app-bar-nav-icon
					@click.stop="$emit('drawer-change')"
				></v-app-bar-nav-icon>
			</div>
			<v-toolbar-title class="white--text">
				<span class="d-none d-sm-inline">Cadastro de </span> Parlamentares
			</v-toolbar-title>
		</v-app-bar> -->

		<v-page-header :color="$root.colorHeader" :titulo="$root.titleHeader" />

		<v-card tile>
			<v-card-title primary-title>
				<router-link to="novo" append tag="span">
					<v-btn primary>
						<v-icon color="primary">mdi-plus</v-icon> Novo
					</v-btn>
				</router-link>
			</v-card-title>
			<v-row class="ml-4 mr-4">
				<v-col md="2">
					<v-select
						outlined
						v-model="esfera"
						:items="esferaItems"
						label="Esfera"
						item-text="descricao"
						item-value="id"
						return-object
					/>
				</v-col>
				<v-col md="10">
					<v-text-field
						outlined
						v-model="searchText"
						label="Pesquisa"
						clearable
						autofocus
					/>
				</v-col>
			</v-row>
			<v-list>
				<template v-for="(parlamentar, index) in parlamentaresFiltrados">
					<v-divider v-if="index > 0" :key="'d' + index"></v-divider>
					<v-list-item @click="editar(parlamentar.id)" :key="parlamentar.id">
						<v-list-item-avatar :color="colorFromName(parlamentar.nome)">
							<span class="white--text headline">{{
								iniciais(parlamentar.nome)
							}}</span>
						</v-list-item-avatar>

						<v-list-item-content>
							<v-list-item-title>{{ parlamentar.nome }}</v-list-item-title>
							<v-list-item-subtitle
								>Esfera:
								{{ parlamentar.ultimoExercicio.esfera }}
								&nbsp;-&nbsp; Período:
								{{ parlamentar.ultimoExercicio.dataInicio | getYear }} -
								{{ parlamentar.ultimoExercicio.dataFim | getYear }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</template>
			</v-list>
			<p
				v-if="!(parlamentares.length && parlamentares.length > 0)"
				class="grey--text  text-center pb-3"
			>
				{{ noDataMessage }}
			</p>
		</v-card>
	</v-container>
</template>

<script>

import VPageHeader from '@/components/PageHeader.vue';

export default {
	name: 'Home',
	data() {
		return {
			esfera: null,
			searchText: null,
			parlamentares: [],
			parlamentaresFiltrados: [],
			loading: false,
			noDataMessage: 'Não foram encontrados registros.',
			esferaItems: []
		};
	},
	watch: {
		parlamentares() {
			this.filtrarResultados();
		},
		esfera() {
			this.filtrarResultados();
		},
		searchText() {
			this.filtrarResultados();
		}
	},
	components: {VPageHeader},
	async created() {
		this.fetchEsferaItems();
		
		this.$root.colorHeader = "purple";
		this.$root.titleHeader = "Cadastro de Parlamentares";

		try {
			this.parlamentares = await this.$fetch.get('parlamentares');
			this.parlamentares.sort(function(a, b) {
				if (a.nome > b.nome) {
					return 1;
				}
				if (a.nome < b.nome) {
					return -1;
				}
				// a must be equal to b
				return 0;
			});
		} catch (err) {
			this.noDataMessage = err.msg;
		}
	},
	methods: {
		iniciais(nome) {
			let arrNome = nome.split(' ');
			return arrNome[0][0] + arrNome[arrNome.length - 1][0];
		},
		colorFromName(name) {
			let firstCharCode = name.toUpperCase().charCodeAt(0) - 65;
			let hue = (firstCharCode * 360) / 26;

			return `hsl(${hue}, 80%, 50%)`;
		},
		novo() {
			this.$router.push('/parlamentares/novo');
		},
		editar(id) {
			this.$router.push(`/parlamentares/${id}`);
		},
		async fetchEsferaItems() {
			this.esferaItems = await this.$fetch.get('parlamentares/esferas');
			this.esferaItems.splice(0, 0, { id: null, descricao: 'Todos' });
			this.esfera = this.esferaItems[0];
		},
		filtrarResultados() {
			let parlamentares = [...this.parlamentares];

			if (this.esfera && this.esfera.id) {
				parlamentares = parlamentares.filter(
					p => p.ultimoExercicio.esfera == this.esfera.descricao
				);
			}

			if (this.searchText) {
				parlamentares = parlamentares.filter(p =>
					p.nome
						.normalize('NFD')
						.replace(/[\u0300-\u036f]/g, '')
						.toUpperCase()
						.includes(
							this.searchText
								.normalize('NFD')
								.replace(/[\u0300-\u036f]/g, '')
								.toUpperCase()
						)
				);
			}

			this.parlamentaresFiltrados = parlamentares;
		}
	},
	filters: {
		getYear(val) {
			return val.split(' ')[0].split('/')[2];
		}
	}
};
</script>

<style scoped>
.head-tile {
	margin: -10px -10px 0 -10px;
}
</style>
